"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCheck = void 0;
var React = __importStar(require("react"));
var IconCheck = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M7.9727,19 C7.9167,19 7.8617,18.997 7.8057,18.99 C7.3837,18.94 7.0087,18.704 6.7877,18.35 L4.1997,12.232 C3.8047,11.596 4.0137,10.768 4.6677,10.382 C5.3217,9.997 6.1717,10.201 6.5677,10.838 L8.2437,14.359 L17.5047,5.524 C18.0447,4.998 19.1527,4.773 19.6927,5.3 C20.2327,5.826 20.0017,6.68 19.4617,7.206 L8.9507,18.605 C8.6897,18.859 8.3367,19 7.9727,19" }))); };
exports.IconCheck = IconCheck;
exports.IconCheck.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconCheck;
